import Button from 'components/Button';
import Icon from 'components/Icon';
import Input from 'components/Input';
import DatePicker from 'components/Input/DatePicker';
import { useToggle, useTranslation } from 'services/hooks';

const Appointment = ({
	meetingId,
	timeFrom,
	timeTo,
	title,
	onUpdate,
	onDelete,
	meetingRemark,
	date,
	remarkDefaultValue,
	allowEdit = true,
	editModeWithRemark = true,
}) => {
	const [editMode, toggleEditMode] = useToggle(false);
	const getTranslation = useTranslation();

	const TRANSLATION_KEY = 'appointment';

	const _handleDelete = () => {
		if (!onDelete || typeof onDelete !== 'function') return;
		onDelete(meetingId);
	};

	const _handleEdit = async e => {
		e?.preventDefault();
		if (!onUpdate || typeof onUpdate !== 'function') return;
		const form = new FormData(e.target);
		const formData = Object.fromEntries(form.entries());
		formData.meetingId = meetingId;
		formData.date = date;
		const succeeded = await onUpdate(formData);
		if (succeeded) toggleEditMode();
	};

	if (editMode)
		return (
			<form onSubmit={_handleEdit}>
				<div className="Appointment">
					<div className="Appointment__time">
						<DatePicker
							type="time"
							fromTo
							label={getTranslation(TRANSLATION_KEY, `${TRANSLATION_KEY}_time_label`)}
							startDateName="startTime"
							endDateName="endTime"
							startDateDefaultValue={timeFrom}
							endDateDefaultValue={timeTo}
						/>
					</div>
					<div className="Appointment__description">
						{editModeWithRemark && (
							<div className="Appointment__description__title">
								<Input
									label={getTranslation(TRANSLATION_KEY, `${TRANSLATION_KEY}_description_label`)}
									defaultValue={remarkDefaultValue}
									name="meetingRemark"
								/>
							</div>
						)}
					</div>
					<div className="Appointment__actions">
						<Button title={getTranslation(TRANSLATION_KEY, `${TRANSLATION_KEY}_button`)} small />
						<Icon icon="closeIcon" onClick={toggleEditMode} />
					</div>
				</div>
			</form>
		);

	return (
		<div className="Appointment">
			<div className="Appointment__time">
				<Icon icon="clockIcon" size={20} />
				{timeFrom} - {timeTo}
			</div>
			<div className="Appointment__description">
				<div className="Appointment__description__title">{title}</div>
				<div className="Appointment__description__paragraph">{meetingRemark}</div>
			</div>
			{allowEdit && (
				<div className="Appointment__actions">
					<Icon icon="editIcon" onClick={toggleEditMode} />
					<Icon icon="trashIcon" onClick={_handleDelete} />
				</div>
			)}
		</div>
	);
};

export default Appointment;
